import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoReferenciasParentescos } from '../_models/producto-referencias-parentescos';

@Injectable({
  providedIn: 'root'
})
export class ProductoReferenciasParentescosService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosReferenciasParentescos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoPorIdProductoReferencia( idProductoReferencia: string ) {
    return this.httClient.get( this.rutServicio + '/productoReferencia/' + idProductoReferencia ).pipe( map( res => res as ProductoReferenciasParentescos[]) );
  }

  bulk(data: ProductoReferenciasParentescos[]){
    return this.httClient.post(this.rutServicio + '/bulk', data).pipe(map(res => res  as ProductoReferenciasParentescos[]));
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoReferenciasParentescos ) );
  }

  crear( regCrear: ProductoReferenciasParentescos ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoReferenciasParentescos ) );
  }

  actualizar( regActualizar: ProductoReferenciasParentescos ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
